var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tva-slider']},[_c('div',{ref:"slider",staticClass:"tva-slider-container"},[_vm._t("default")],2),(_vm.dots)?_c('div',{staticClass:"tva-dots",style:({ top: ("calc(" + _vm.dotsPosition + "% - " + (_vm.dotsSize / 2) + "px") })},_vm._l((_vm.elementsCount),function(dot,dotIndex){return _c('div',{key:'dot-' + dotIndex,staticClass:"tva-dot",style:({
        background: _vm.index === dotIndex ? _vm.dotActiveBgColor : _vm.dotBgColor,
        border: ("solid " + _vm.dotStrokeWidth + "px " + (_vm.index === dotIndex ? _vm.dotActiveStrokeColor : _vm.dotStrokeColor)),
        marginRight: _vm.dotGap + 'px',
        width: _vm.dotsSize + 'px',
        height: _vm.dotsSize + 'px'
      }),on:{"click":function($event){return _vm.goTo(dotIndex)}}})}),0):_vm._e(),(_vm.arrows)?_c('div',{staticClass:"tva-arrows",style:({ top: ("calc(" + _vm.arrowsPosition + "% - " + (_vm.arrowsSize / 2) + "px)") })},[_c('div',{staticClass:"tva-arrow tva-arrow-sx",style:({
        borderColor:
          _vm.index === 0 ? _vm.arrowDisabledBorderColor : _vm.arrowBorderColor,
        borderWidth: _vm.arrowBorderWidth + 'px',
        background: _vm.index === 0 ? _vm.arrowDisabledBgColor : _vm.arrowBgColor,
        width: _vm.arrowsSize + 'px',
        height: _vm.arrowsSize + 'px',
        pointerEvents: _vm.index === 0 ? 'none' : 'all'
      }),on:{"click":function($event){return _vm.goPrevious()}}},[_c('svg',{staticClass:"tva-arrow-icon",attrs:{"viewBox":"0 0 100 100"}},[_c('path',{style:({ fill: _vm.index === 0 ? _vm.arrowDisabledColor : _vm.arrowColor }),attrs:{"d":"M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"}})])]),_c('div',{staticClass:"tva-arrow tva-arrow-dx",style:({
        borderColor:
          _vm.index === _vm.elementsCount.length - 1
            ? _vm.arrowDisabledBorderColor
            : _vm.arrowBorderColor,
        borderWidth: _vm.arrowBorderWidth + 'px',
        background:
          _vm.index === _vm.elementsCount.length - 1
            ? _vm.arrowDisabledBgColor
            : _vm.arrowBgColor,
        width: _vm.arrowsSize + 'px',
        height: _vm.arrowsSize + 'px',
        pointerEvents: _vm.index === _vm.elementsCount.length - 1 ? 'none' : 'all'
      }),on:{"click":function($event){return _vm.goNext()}}},[_c('svg',{staticClass:"tva-arrow-icon",attrs:{"viewBox":"0 0 100 100"}},[_c('path',{style:({
            fill:
              _vm.index === _vm.elementsCount.length - 1
                ? _vm.arrowDisabledColor
                : _vm.arrowColor
          }),attrs:{"d":"M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z","transform":"translate(100, 100) rotate(180)"}})])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }